import React, { useCallback } from 'react';
import { useFormContext, useController } from 'react-hook-form';

import { Select as SelectBase, ISelectProps } from '../../select';
import { IAdditionalFormProps, TFormExtendedProps } from '../form.models';

export const Select = ({
  name,
  helperText,
  onChangeDependecies,
  paperStyles,
  listStyles,
  itemStyles,
  onCustomChange,
  onSelectChange,
  ...props
}: TFormExtendedProps<ISelectProps>): JSX.Element => {
  const { control, formState: { errors } } = useFormContext();
  const {
    field: { ref, onChange, ...restField },
    fieldState: { invalid },
  } = useController({
    name,
    control,
  });
  const additionalProps: IAdditionalFormProps = {};

  if (invalid) {
    additionalProps.error = true;
    additionalProps.helperText = errors[name]?.message;
  } else if (helperText) {
    additionalProps.helperText = helperText;
  }

  const handleChange = useCallback((...values: unknown[]) => {
    onChange(...values);

    if (onSelectChange) {
      onSelectChange();
    }

    if (onCustomChange) {
      onCustomChange(((values[0] as PointerEvent).target as HTMLOptionElement)!.value);
    }

    if (onChangeDependecies) {
      onChangeDependecies();
    }
  }, [onChange, onChangeDependecies, onCustomChange]);

  return (
    <SelectBase
      {...props}
      {...restField}
      {...additionalProps}
      onChange={handleChange}
      paperStyles={paperStyles}
      listStyles={listStyles}
      itemStyles={itemStyles}
    />
  );
};
